<template>
  <b-modal
    v-model="isOpen"
    has-modal-card
    trap-focus
    scroll="keep"
    aria-role="dialog"
    aria-label="CourrielModal"
    :aria-modal="true"
    class="CourrielModal"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <H3TitleView class="modal-card-title"
          >{{ $t("instruction-panel.echanges.courriel") }}
        </H3TitleView>
        <div class="ActualitesModalView-infos">
          {{
            `${$t("instruction-panel.echanges.date-envoi")} ${formatDate(courriel.dateCreation)}${
              courriel.auteur ? " par " + courriel.auteur.prenom + " " + courriel.auteur.nom : ""
            }`
          }}
        </div>
      </header>

      <section class="modal-card-body">
        <InputWithValidation
          v-model="titre"
          class="courriel-title"
          type="textarea"
          :label="$t('instruction-panel.echanges.courriel-title')"
          maxlength="140"
          vid="courriel-title"
          :disabled="true"
        />

        <InputWithValidation
          v-model="contenuBrut"
          class="courriel-content"
          type="textarea"
          :label="$t('instruction-panel.echanges.courriel-content')"
          maxlength="1400"
          vid="courriel-content"
          :disabled="true"
        />
      </section>

      <footer class="modal-card-foot">
        <div class="buttons">
          <div class="hoverable-discrete-link mr-3" @click="emitCloseModale">
            {{ $t("close-generic") }}
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { EchangeDTO } from "@/model/bean/GeneratedDTOs"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import { BModal } from "buefy"

import DateUtils from "@/services/DateUtils"

export default defineComponent({
  name: "CourrielModalView",
  components: {
    H3TitleView,
    InputWithValidation,
    BModal,
  },
  props: {
    courriel: {
      type: Object as PropType<EchangeDTO>,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },

  emits: ["close"],
  data() {
    return {
      courrielCopy: { ...this.courriel },
    }
  },
  computed: {
    isOpen: {
      get(): boolean {
        return this.open
      },
      set(value: boolean): void {
        if (!value) {
          this.emitCloseModale()
        }
      },
    },
    contenuBrut(): string {
      return this.htmlToPlainTextWithLineBreaks(this.courrielCopy.contenu)
    },
    titre: {
      get(): string {
        return this.courrielCopy.titre
      },
      set(): void {
        // Ne rien faire puisque le champ est en lecture seule
      },
    },
  },
  watch: {
    courriel: {
      handler(newCourriel) {
        this.courrielCopy = { ...newCourriel }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    emitCloseModale(): void {
      this.$emit("close")
    },

    formatDate(date: Date): string {
      return DateUtils.formatDate(date)
    },

    htmlToPlainTextWithLineBreaks(html: string): string {
      if (!html) return ""
      let text = html.replace(/<br\s*\/?>/gi, "\n")
      text = text.replace(/<\/p>/gi, "\n")
      const tempElement = document.createElement("div")
      tempElement.innerHTML = text
      return tempElement.textContent || tempElement.innerText || ""
    },
  },
})
</script>

<style lang="scss">
.CourrielModal {
  &.modal .modal-card {
    height: 76%;
    overflow-y: auto !important;
  }

  .animation-content {
    height: 100%;
  }

  .courriel-title textarea {
    min-height: 75px;
    height: 75px;
  }

  .courriel-content textarea {
    height: 320px;
  }
}

.CourrielModalView-infos {
  font-style: italic;
}
</style>
